import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Member } from '../../models/member.model';
import { MemberState, memberAdapter } from '../reducers/member.reducer';

export const getMemberState = createFeatureSelector<MemberState>('members');
export const getIds = (state: MemberState) => state.ids;
export const memberStatsLoading = (state: MemberState) =>
  state.memberStatsLoading;
export const loading = (state: MemberState) => state.loading;
export const inProgress = (state: MemberState) => state.inProgress;

export const {
  selectIds: getMemberIds,
  selectEntities: getMemberEntities,
  selectAll: getAllMembers,
  selectTotal: getTotalMembers,
} = memberAdapter.getSelectors(getMemberState);

export const getMemberById = (memberId: string) =>
  createSelector(getAllMembers, (allItems) => {
    if (allItems) {
      return allItems.find((item) => {
        return item.id === memberId;
      });
    } else {
      return null;
    }
  });

export const getMembersByGroupId = (groupId: string) =>
  createSelector(getAllMembers, (allItems) => {
    // if (allItems) {
    return allItems
      .filter((item) => {
        return item.groupId === groupId;
      })
      .sort(sortDescendingByModifiedDate);
  });

export const getMembersIdsByGroup = (groupId: string) =>
  createSelector(getAllMembers, (allItems) => {
    return allItems
      .filter((item) => {
        return item.groupId === groupId;
      })
      .map((item) => item.id);
  });

function sortDescendingByModifiedDate(a: Member, b: Member): number {
  return a.modified.toDate() > b.modified.toDate()
    ? -1
    : a.modified.toDate() < b.modified.toDate()
    ? 1
    : 0;
}
